const isDebugModeActivated = process.env.REACT_APP_DEBUG_MODE === 'true';
const isFromActionsPlaceActivated = process.env.REACT_APP_DEBUG_PLACE_ACTIONS === 'true';
const isFromPagesPlaceActivated = process.env.REACT_APP_DEBUG_PLACE_PAGES === 'true';
const isFromReducerPlaceActivated = process.env.REACT_APP_DEBUG_PLACE_REDUCERS === 'true';


/*** General ***/
export const debugLog = (...args) => {
    if (isDebugModeActivated) {
        console.log(...args);
    }
};

export const debugWarn = (...args) => {
    if (isDebugModeActivated) {
        console.warn(...args);
    }
};

export const debugError = (...args) => {
    if (isDebugModeActivated) {
        console.error(...args);
    }
};

export const debugTable = (...args) => {
    if (isDebugModeActivated) {
        console.table(...args);
    }
};

/*** Actions ***/
export const debugLogActions = (...args) => {
    if (isDebugModeActivated && isFromActionsPlaceActivated) {
        console.log(...args);
    }
};

export const debugWarnActions = (...args) => {
    if (isDebugModeActivated && isFromActionsPlaceActivated) {
        console.warn(...args);
    }
};

export const debugErrorActions = (...args) => {
    if (isDebugModeActivated && isFromActionsPlaceActivated) {
        console.error(...args);
    }
};

export const debugTableActions = (...args) => {
    if (isDebugModeActivated && isFromActionsPlaceActivated) {
        console.table(...args);
    }
};

/*** Pages ***/
export const debugLogPages = (...args) => {
    if (isDebugModeActivated && isFromPagesPlaceActivated) {
        console.log(...args);
    }
};

export const debugWarnPages = (...args) => {
    if (isDebugModeActivated && isFromPagesPlaceActivated) {
        console.warn(...args);
    }
};

export const debugErrorPages = (...args) => {
    if (isDebugModeActivated && isFromPagesPlaceActivated) {
        console.error(...args);
    }
};

export const debugTablePages = (...args) => {
    if (isDebugModeActivated && isFromPagesPlaceActivated) {
        console.table(...args);
    }
};


/*** Reducers ***/
export const debugLogReducer = (...args) => {
    if (isDebugModeActivated && isFromReducerPlaceActivated) {
        console.log(...args);
    }
};

export const debugWarnReducer = (...args) => {
    if (isDebugModeActivated && isFromReducerPlaceActivated) {
        console.warn(...args);
    }
};

export const debugErrorReducer = (...args) => {
    if (isDebugModeActivated && isFromReducerPlaceActivated) {
        console.error(...args);
    }
};

export const debugTableReducer = (...args) => {
    if (isDebugModeActivated && isFromReducerPlaceActivated) {
        console.table(...args);
    }
};